import React from 'react';

import BootstrapTable from 'react-bootstrap-table-next';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

import { PropTypes } from 'prop-types';
import { getIntegerWithDecimalSeparator } from '../../../../../../util/NumberFormatter';

const tableStyle = {
   verticalAlign: 'middle',
   textAlign: 'center',
   color: '#FFF',
   fontSize: '12px',
   borderColor: 'rgba(0,0,0,0)',
   padding: '0px',
};

const columnsHeader = [
   {
      dataField: 'name',
      text: 'ABR profile switched to',
      style: tableStyle,
      headerStyle: { ...tableStyle, width: '130px', textAlign: 'left' },
   },
   {
      dataField: 'switches',
      text: 'Count',
      headerStyle: { ...tableStyle, width: '90px' },
   },
];

const columnsBody = [
   {
      dataField: 'name',
      text: '',
      style: { ...tableStyle, textAlign: 'left' },
      headerAlign: 'left',
      headerStyle: { ...tableStyle, width: '130px', textAlign: 'left' },
   },
   {
      dataField: 'switches',
      text: '',
      style: {
         ...tableStyle,
         textAlign: 'right',
         paddingRight: '5px',
         borderRight: '1px solid rgba(255, 255, 255, 0.95)',
      },
      formatter: (cell) => getIntegerWithDecimalSeparator(cell),
      headerAlign: 'right',
      headerStyle: { ...tableStyle, textAlign: 'right', width: '53px' },
   },
   {
      dataField: 'percentage',
      text: '',
      style: { ...tableStyle, textAlign: 'left', paddingLeft: '4px' },
      formatter: (cell) => `${cell} %`,
      headerAlign: 'left',
      headerStyle: { ...tableStyle, textAlign: 'left', width: '40px' },
   },
];

function AbrSwitchesTable({ data }) {
   return (
      <>
         <BootstrapTable keyField='name' data={[]} columns={columnsHeader} classes='head-abr-table' bootstrap4 />
         <BootstrapTable keyField='name' data={data} columns={columnsBody} classes='headless-abr-table' bootstrap4 />
      </>
   );
}

AbrSwitchesTable.propTypes = {
   data: PropTypes.arrayOf(
      PropTypes.shape({
         name: PropTypes.string,
         switches: PropTypes.number,
         percentage: PropTypes.number,
      }),
   ),
};

export default AbrSwitchesTable;
